export default {
  "content": "<g clip-path=\"url(#clip0_642_47413)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.078 6.35A.46.46 0 002 6.609v8.113a2.287 2.287 0 001.1 1.927l4.727 3.1a.327.327 0 00.346 0l4.727-3.1a2.286 2.286 0 001.1-1.927V6.608a.46.46 0 00-.287-.427l-5.54-2.246a.447.447 0 00-.346 0L2.287 6.18a.46.46 0 00-.209.17zm8.825 3.972l-3.01 4.515a.751.751 0 01-.55.339h-.075a.753.753 0 01-.534-.219L5.23 13.452a.756.756 0 111.069-1.068l.85.858 2.506-3.763a.752.752 0 011.249.828v.015z\" fill=\"#017939\"/></g><defs><clipPath id=\"clip0_642_47413\"><path fill=\"#fff\" transform=\"translate(0 .861)\" d=\"M0 0h16v19H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "20",
    "viewBox": "0 0 16 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};